import React from "react";
import { useState } from "react";
import { LawFirmAutoSuggest } from '../../form';
import ReferralForm from "../referralForm/ReferralForm";
import { ReactComponent as ImageSearchIcon } from '../../../assets/imgs/ui-search-icon.svg';

const FirmSearch = ({ lawFirm, setLawFirm, selectedOfficeId, userName, loggedInLawFirmName }) => {
    const [hide, setHide] = useState(true);

    const arrow = {
        cursor: 'pointer',
    };

    const imgHeight = {
        height: '75px',
    };

    const colourStyle = {
        color: 'black'
    }

    const block = {
        display: 'inline-block'
    }

    const handleClick = (event) => {
        setHide(!hide);
    }

    const [searchId, setSearchId] = useState(null);

    return (
        <div data-testid="firm-search">
            <div className="row fw-bold pb-3">
                <div className="col-12">
                    Start the search
                </div>
            </div>
            <div className="row">
                <div className="col-12 pb-4">
                    Start typing the company name or postcode in the search field, then click your preferred match from the list to proceed.
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    Find a firm
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <LawFirmAutoSuggest 
                        setLawFirm={setLawFirm} 
                        selectedOfficeId={selectedOfficeId} 
                        loggedInLawFirmName={loggedInLawFirmName} 
                        userName={userName} 
                        setSearchId={setSearchId} 
                    />
                </div>
            </div>

            {lawFirm !== null ? (null) : (
                <>
                    <div data-testid="firm-search-not-found" className="row pb-3" onClick={handleClick}>
                        <div className="col-12" style={arrow}>
                            <u>Law firm not found?</u>
                        </div>
                    </div>

                    {hide ?
                        (<div className="row">
                            &nbsp;
                        </div>)
                        :
                        (<>
                            <div className="row pt-3">
                                <div className="col-12 fs-3">
                                    <ImageSearchIcon style={imgHeight}  />
                                    &nbsp;&nbsp;&nbsp;TRY OUR SEARCH TIPS
                                </div>
                            </div>
                            <div className="row">
                                &nbsp;
                            </div>
                            <div className="row">
                                <div className="col-12" style={block}>
                                    <span style={colourStyle}>
                                        <b>Extend the length</b>&nbsp;-&nbsp;
                                    </span>
                                    <span>
                                        if you have only entered 3 characters maybe try more?
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                &nbsp;
                            </div>
                            <div className="row">
                                <div className="col-12" style={block}>
                                    <span style={colourStyle}>
                                        <b>Check the spelling</b>&nbsp;-&nbsp;
                                    </span>
                                    <span>
                                        you might have missed a character?
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                &nbsp;
                            </div>
                            <div className="row">
                                <div className="col-12" style={block}>
                                    <span style={colourStyle}>
                                        <b>Try searching for a different critieria</b>&nbsp;-&nbsp;
                                    </span>
                                    <span>
                                        if you have entered the name, maybe try the postcode instead?
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                &nbsp;
                            </div>
                            <div className="row">
                                &nbsp;
                            </div>
                            {
                                //MUST HAVE COMPLETED A SEARCH
                                searchId &&
                                <div className="row">
                                <div className="col-12" style={block}>
                                    <ReferralForm 
                                        selectedOfficeId={selectedOfficeId} 
                                        username={userName} 
                                        loggedInLawFirmName={loggedInLawFirmName}
                                        searchId={searchId}
                                    />
                                </div>
                            </div>
                            }

                        </>
                        )}
                </>
            )}

            <div className="row">
                &nbsp;
            </div>
        </div>
    );
}

export default FirmSearch;